module.exports = __webpack_public_path__ + "img/3.d82ad0d5.jpg";